import React, { useEffect, useState } from "react";
import {NavLink} from "react-router";
import Search from "./Search";
function Header () {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
   const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
   };
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  
    const toggleSearchOpen = () => {
      setIsSearchOpen(!isSearchOpen);
   };

  const [sticky, setSticky] = useState("");
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? "sticky" : "";
    setSticky(stickyClass);
  };

   const [currency, setCurrency] = useState(
    localStorage.getItem("currency") || "inr"
  );

  const handleCurrencyChange = (e) => {
    const value = e.target.value;
    setCurrency(value);
    localStorage.setItem("currency", value);

    window.dispatchEvent(new Event("currency-change"));
  };
    return(
<>
  <div id="magic-cursor">
    <div id="ball" />
  </div>
  {/* Back To Top */}
  <div className="progress-wrap">
    <svg
      className="progress-circle svg-content"
      width="100%"
      height="100%"
      viewBox="-1 -1 102 102"
    >
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
    <svg
      className="arrow"
      width={22}
      height={25}
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.556131 11.4439L11.8139 0.186067L13.9214 2.29352L13.9422 20.6852L9.70638 20.7061L9.76793 8.22168L3.6064 14.4941L0.556131 11.4439Z" />
      <path d="M23.1276 11.4999L16.0288 4.40105L15.9991 10.4203L20.1031 14.5243L23.1276 11.4999Z" />
    </svg>
  </div>
  {/* header Section Start*/}
  <header className={`header-area style-3 two ${sticky}`}>
    <div className="container-fluid d-flex flex-nowrap align-items-center justify-content-between">
      <div className="logo-and-menu-area">
        <a href="/" className="header-logo">
          <img src="/assets/img/site-logo.PNG" alt="" />
        </a>
        <div className={`main-menu menu-container ${isMenuOpen ? 'show-menu' : ''}`}>
          <div className="mobile-logo-area d-xl-none d-flex align-items-center justify-content-between">
            <a href="/" className="mobile-logo-wrap">
              <img src="/assets/img/site-logo.PNG" alt="" />
            </a>
            <div className="menu-close-btn" onClick={toggleMenu} >
              <i className="bi bi-x" />
            </div>
          </div>
        <ul className="menu-list">
            <li className={({ isActive, isPending }) =>
                  isActive
                    ? "active"
                    : isPending
                      ? "pending"
                      : ""
                }>
            <NavLink to="/" end  className="drop-down">
              Home
            </NavLink>
           
          </li>
           <li >
            <NavLink to="/about" end  className="drop-down">
              About
            </NavLink>
           
          </li>
            <li className="menu-item-has-children ">
              <NavLink to="/destination" end className="drop-down">
                Destination
              </NavLink>
              
            </li>
            <li className="menu-item-has-children">
              <NavLink to="/package" className="drop-down">
                Package
              </NavLink>
            </li>
             <li className="menu-item-has-children">
              <NavLink to="/activity" className="drop-down">
                Activities
                
              </NavLink>
             
            </li>
             {/* <li className="menu-item-has-children">
              <NavLink to="/hotel" className="drop-down">
                Hotel
              </NavLink>
              
            
            </li> */}
            <li className="menu-item-has-children">
              <NavLink to="/blog" className="drop-down">
                Blog
              </NavLink>
            
            </li>
            <li className="menu-item-has-children">
              <NavLink to="/visa" className="drop-down">
                Visa
              </NavLink>
             
            </li>
  <li className="menu-item-has-children">
              <NavLink to="/cruise" className="drop-down">
                Cruise
              </NavLink>
               
            </li>
            
            <li className="menu-item-has-children">
              <NavLink to="/contact" className="drop-down">
                Contact Us
              </NavLink>
             
            </li>
         
          </ul>
          <div className="contact-area d-xl-none d-flex">
            <div className="icon">
              <svg
                width={16}
                height={16}
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M15.5646 11.7424L13.3317 9.50954C12.5343 8.7121 11.1786 9.03111 10.8596 10.0678C10.6204 10.7855 9.82296 11.1842 9.10526 11.0247C7.51037 10.626 5.35726 8.55261 4.95854 6.87797C4.71931 6.16024 5.19778 5.36279 5.91548 5.12359C6.95216 4.80461 7.27113 3.44895 6.47369 2.65151L4.24084 0.418659C3.60288 -0.139553 2.64595 -0.139553 2.08774 0.418659L0.572591 1.93381C-0.942555 3.5287 0.73208 7.75516 4.48007 11.5032C8.22807 15.2512 12.4545 17.0056 14.0494 15.4106L15.5646 13.8955C16.1228 13.2575 16.1228 12.3006 15.5646 11.7424Z" />
                </g>
              </svg>
            </div>
            <div className="content ">
              <span>Need Help?</span>
              <a href="tel:+97158 437355">+971 58 543 7355</a>
            </div>
          </div>
        </div>
      </div>
      <div className="nav-right">


<select
  value={currency}
  onChange={handleCurrencyChange}
  className="rounded-select"
>
  <option value="inr">INR</option>
  <option value="usd">USD</option>
  <option value="aed">AED</option>
</select>

<style>
{`
.rounded-select {
    padding:3px 14px;
    border-radius: 50px;
    border: 2px solid #c1c1c1;
    background: #fff;
    font-size: 14px;
    color: #333;
    outline: none;
    transition: 0.3s;
}

`}
</style>


      
        <div className="contact-area d-xl-flex d-none">
          <div className="icon">
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M15.5646 11.7424L13.3317 9.50954C12.5343 8.7121 11.1786 9.03111 10.8596 10.0678C10.6204 10.7855 9.82296 11.1842 9.10526 11.0247C7.51037 10.626 5.35726 8.55261 4.95854 6.87797C4.71931 6.16024 5.19778 5.36279 5.91548 5.12359C6.95216 4.80461 7.27113 3.44895 6.47369 2.65151L4.24084 0.418659C3.60288 -0.139553 2.64595 -0.139553 2.08774 0.418659L0.572591 1.93381C-0.942555 3.5287 0.73208 7.75516 4.48007 11.5032C8.22807 15.2512 12.4545 17.0056 14.0494 15.4106L15.5646 13.8955C16.1228 13.2575 16.1228 12.3006 15.5646 11.7424Z" />
              </g>
            </svg>
          </div>
          <div className="content help-dropdown">
  <span className="help-title">Need Help?</span>
<a href="tel:+971585437355">+971 585437355<i class="bi bi-caret-down-fill"></i></a>
  <div className="help-menu">
    <a href="tel:+919971052001">+91 9971052001</a>
  </div>
</div>

        </div>
        <div className="search-and-login">
          <div className="search-bar">
            <div className="search-btn" onClick={toggleSearchOpen}>
              <svg
                width={16}
                height={16}
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M15.7417 14.6098L13.486 12.3621C14.7088 10.8514 15.3054 8.9291 15.1526 6.99153C14.9998 5.05396 14.1093 3.24888 12.6648 1.94851C11.2203 0.648146 9.33193 -0.0483622 7.38901 0.00261294C5.44609 0.0535881 3.59681 0.84816 2.22248 2.22248C0.84816 3.59681 0.0535881 5.44609 0.00261294 7.38901C-0.0483622 9.33193 0.648146 11.2203 1.94851 12.6648C3.24888 14.1093 5.05396 14.9998 6.99153 15.1526C8.9291 15.3054 10.8514 14.7088 12.3621 13.486L14.6098 15.7417C14.6839 15.8164 14.7721 15.8757 14.8692 15.9161C14.9664 15.9566 15.0705 15.9774 15.1758 15.9774C15.281 15.9774 15.3852 15.9566 15.4823 15.9161C15.5794 15.8757 15.6676 15.8164 15.7417 15.7417C15.8164 15.6676 15.8757 15.5794 15.9161 15.4823C15.9566 15.3852 15.9774 15.281 15.9774 15.1758C15.9774 15.0705 15.9566 14.9664 15.9161 14.8692C15.8757 14.7721 15.8164 14.6839 15.7417 14.6098ZM1.62572 7.60368C1.62572 6.42135 1.97632 5.26557 2.63319 4.2825C3.29005 3.29943 4.22368 2.53322 5.31601 2.08076C6.40834 1.62831 7.61031 1.50992 8.76992 1.74058C9.92953 1.97124 10.9947 2.54059 11.8307 3.37662C12.6668 4.21266 13.2361 5.27783 13.4668 6.43744C13.6974 7.59705 13.579 8.79902 13.1266 9.89134C12.6741 10.9837 11.9079 11.9173 10.9249 12.5742C9.94178 13.231 8.78601 13.5816 7.60368 13.5816C6.01822 13.5816 4.49771 12.9518 3.37662 11.8307C2.25554 10.7096 1.62572 9.18913 1.62572 7.60368Z" />
                </g>
              </svg>
            </div>
            <div  className={`search-input ${isSearchOpen ? 'active' : ''}`}>
              <div className="search-close"  onClick={toggleSearchOpen}/>
              <Search></Search>
            </div>
          </div>
        </div>
        <div className="sidebar-button mobile-menu-btn test" onClick={toggleMenu}> 
          <svg
            width={20}
            height={18}
            viewBox="0 0 20 18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.29445 2.8421H10.5237C11.2389 2.8421 11.8182 2.2062 11.8182 1.42105C11.8182 0.635903 11.2389 0 10.5237 0H1.29445C0.579249 0 0 0.635903 0 1.42105C0 2.2062 0.579249 2.8421 1.29445 2.8421Z" />
            <path d="M1.23002 10.421H18.77C19.4496 10.421 20 9.78506 20 8.99991C20 8.21476 19.4496 7.57886 18.77 7.57886H1.23002C0.550421 7.57886 0 8.21476 0 8.99991C0 9.78506 0.550421 10.421 1.23002 10.421Z" />
            <path d="M18.8052 15.1579H10.2858C9.62563 15.1579 9.09094 15.7938 9.09094 16.5789C9.09094 17.3641 9.62563 18 10.2858 18H18.8052C19.4653 18 20 17.3641 20 16.5789C20 15.7938 19.4653 15.1579 18.8052 15.1579Z" />
          </svg>
        </div>
      </div>
    </div>
  </header>
  {/* header Section End*/}
</>


    )
}
export default Header;